import React from 'react';

interface WorkersCounterProps {
  value: number;
  onChange: (value: number) => void;
  error?: string;
  touched?: boolean;
}

const WorkersCounter: React.FC<WorkersCounterProps> = ({
  value,
  onChange,
  error,
  touched,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value) || 1;
    onChange(Math.max(1, Math.min(10, newValue)));
  };

  return (
    <div>
      <label className="mb-1 block text-sm font-medium">
        How many workers do you need
      </label>
      <input
        type="number"
        value={value}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            // When this is rendered inside a form, pressing enter will submit the form.
            // We don't want that. Disable it.
            e.preventDefault();
          }
        }}
        min="1"
        max="10"
        className="w-full rounded border border-gray-300 px-3 py-2 text-gray-600 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none"
        placeholder="1"
      />
      <div className="mt-1 text-xs text-gray-500">
        This will create {value} job posting{value !== 1 ? 's' : ''}
      </div>
      {touched && error && (
        <div className="mt-1 text-xs text-red-500">{error}</div>
      )}
    </div>
  );
};

export default WorkersCounter;
